module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/main-visual_american-village-e3059e9c3f598a1f988ae094b50e2b5b.webp";